import { useTranslation } from 'next-i18next'
import { memo } from 'react'

import { ButtonPrimary } from '~/components/Buttons'
import stylesTouchScreen from '~/shared/components/Cards/CardsTouchScreen.module.css'
import stylesNonTouchScreen from '~/shared/components/Cards/CardsNonTouchScreen.module.css'
import { Link } from '~/components'
import { isTouchDevice } from '~/utils'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '18px' }]
interface Props {
  href: string
  buttonTitle: string
  description: string
  navigationDirection?: 'left' | 'right'
}

export default memo(function ArticleNavigationCard({
  href,
  buttonTitle,
  description,
  navigationDirection,
}: Props): React.ReactElement {
  const { t } = useTranslation(['imageAlt'])

  const isTouchScreen = isTouchDevice()

  return (
    <div
      className={`rounded active:ring-8 active:ring-purple-light border-2 border-white ${
        isTouchScreen ? stylesTouchScreen['navigation-card'] : stylesNonTouchScreen['navigation-card']
      }`}
    >
      <div className="text-white">
        <ButtonPrimary
          className="rounded-b-none ring-0 truncate"
          disableRing
          disableTransition
          href={href}
          isFullWidth
          link="internal"
          size="small"
        >
          {navigationDirection === 'left' && (
            <ResponsiveImage
              alt={t('imageAlt:icons.arrowLeft')}
              height={13}
              imageClassName="w-[18px] h-[13px] rotate-180 mr-6"
              imageWidths="18, 36, 54"
              mediaQuery={mediaQuery}
              srcKey="icons/arrow-right.png"
              width={18}
            />
          )}
          {buttonTitle}
          {navigationDirection === 'right' && (
            <ResponsiveImage
              alt={t('imageAlt:icons.arrowRight')}
              height={13}
              imageClassName="min-w-[18px] h-[13px] ml-2"
              imageWidths="18, 36, 54"
              mediaQuery={mediaQuery}
              srcKey="icons/arrow-right.png"
              width={18}
            />
          )}
        </ButtonPrimary>
      </div>
      <div className="bg-white/80 p-3 rounded-b-small max-w-full">
        <Link to={href}>
          <span className="text-xxs text-sub-text underline truncate block">{description}</span>
        </Link>
      </div>
    </div>
  )
})
